// Line Item Quantity Control Script
(function() {
  'use strict';
  
  // Track if we're currently processing an update
  let isUpdating = false;
  
  // Debounce function to prevent multiple rapid updates
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Function to update minus button icon based on quantity
  function updateMinusButton(button, currentQuantity) {
    if (!button) return;
    
    const minusIcon = button.querySelector('.minus-icon');
    const trashIcon = button.querySelector('.trash-icon');
    
    if (currentQuantity > 1) {
      if (minusIcon) minusIcon.style.display = 'block';
      if (trashIcon) trashIcon.style.display = 'none';
    } else {
      if (minusIcon) minusIcon.style.display = 'none';
      if (trashIcon) trashIcon.style.display = 'block';
    }
  }

  // Function to update cart via AJAX
  function updateCart(lineKey, quantity) {
    if (isUpdating) {
      console.log('Update already in progress, skipping...');
      return Promise.resolve();
    }
    
    isUpdating = true;
    
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated successfully:', data);
      
      // Trigger cart update event
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      
      // Wait a bit before allowing next update
      setTimeout(() => {
        isUpdating = false;
      }, 300);
      
      return data;
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      isUpdating = false;
      throw error;
    });
  }

  // Initialize function for buttons
  function initializeButtons() {
    document.querySelectorAll('.minus-btn').forEach(function(button) {
      const currentQuantity = parseInt(button.getAttribute('data-quantity'));
      updateMinusButton(button, currentQuantity);
    });
  }

  // Remove all existing listeners before adding new ones
  function cleanupListeners() {
    // Mark buttons as initialized to prevent duplicate handlers
    document.querySelectorAll('.quantity-control-btn').forEach(btn => {
      btn.dataset.initialized = 'true';
    });
  }

  // Handle button clicks with delegation
  function handleQuantityChange(e) {
    const minusBtn = e.target.closest('.minus-btn');
    const plusBtn = e.target.closest('.plus-btn');
    
    if (!minusBtn && !plusBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    // Check if button is disabled or already initialized for this click
    const button = minusBtn || plusBtn;
    if (button.disabled || isUpdating) {
      console.log('Button disabled or update in progress');
      return;
    }
    
    if (minusBtn) {
      handleMinusClick(minusBtn);
    } else if (plusBtn) {
      handlePlusClick(plusBtn);
    }
  }

  function handleMinusClick(minusBtn) {
    const currentQuantity = parseInt(minusBtn.getAttribute('data-quantity'));
    const lineKey = minusBtn.getAttribute('data-line-key');
    const input = minusBtn.nextElementSibling;
    
    if (currentQuantity <= 1) {
      // Remove item from cart
      if (lineKey) {
        minusBtn.disabled = true;
        updateCart(lineKey, 0)
          .then(() => {
            // Cart will refresh automatically
          })
          .catch(() => {
            minusBtn.disabled = false;
          });
      }
    } else {
      // Decrease quantity
      const newQuantity = currentQuantity - 1;
      
      if (input && input.classList.contains('quantity-input')) {
        input.value = newQuantity;
        minusBtn.setAttribute('data-quantity', newQuantity);
        updateMinusButton(minusBtn, newQuantity);
        
        if (lineKey) {
          minusBtn.disabled = true;
          updateCart(lineKey, newQuantity)
            .then(() => {
              minusBtn.disabled = false;
            })
            .catch(() => {
              minusBtn.disabled = false;
            });
        }
      }
    }
  }

  function handlePlusClick(plusBtn) {
    const input = plusBtn.previousElementSibling;
    const lineKey = plusBtn.getAttribute('data-line-key');
    
    if (input && input.classList.contains('quantity-input')) {
      let currentValue = parseInt(input.value) || 1;
      
      const maxQuantity = plusBtn.getAttribute('data-max') || input.getAttribute('max');
      if (maxQuantity && currentValue >= parseInt(maxQuantity)) {
        console.log('Maximum quantity reached');
        return;
      }
      
      const newValue = currentValue + 1;
      input.value = newValue;
      
      const minusBtn = input.previousElementSibling;
      if (minusBtn && minusBtn.classList.contains('minus-btn')) {
        minusBtn.setAttribute('data-quantity', newValue);
        updateMinusButton(minusBtn, newValue);
      }
      
      if (lineKey) {
        plusBtn.disabled = true;
        updateCart(lineKey, newValue)
          .then(() => {
            plusBtn.disabled = false;
          })
          .catch(() => {
            plusBtn.disabled = false;
          });
      }
    }
  }

  // Handle manual input changes
  const handleInputChange = debounce(function(e) {
    if (e.target.classList.contains('quantity-input')) {
      const input = e.target;
      const newQuantity = parseInt(input.value) || 1;
      const lineKey = input.getAttribute('data-line-key');
      
      if (isUpdating) return;
      
      const minusBtn = input.previousElementSibling;
      if (minusBtn && minusBtn.classList.contains('minus-btn')) {
        minusBtn.setAttribute('data-quantity', newQuantity);
        updateMinusButton(minusBtn, newQuantity);
      }
      
      if (lineKey) {
        updateCart(lineKey, newQuantity);
      }
    }
  }, 500);

  // Single event listener for all clicks
  document.addEventListener('click', handleQuantityChange, true);
  
  // Single event listener for input changes
  document.addEventListener('change', handleInputChange, true);

  // Initialize
  initializeButtons();
  cleanupListeners();

  // Re-initialize on cart updates
  const debouncedInit = debounce(initializeButtons, 200);
  document.addEventListener('cart:refresh', debouncedInit);
  document.addEventListener('cart-drawer:open', debouncedInit);

  console.log('Line item quantity controls initialized');
})();